export default values => ({
  fullName: values ? values.fullName : '',
  email: values ? values.email : '',
  phone: values ? values.phone : '',
  sendNotifications: values ? values.sendNotifications : true,
  role: values ? values.role : null,
});
